import { render, staticRenderFns } from "./boothMap.vue?vue&type=template&id=22fcc31f&scoped=true&"
import script from "./boothMap.vue?vue&type=script&lang=js&"
export * from "./boothMap.vue?vue&type=script&lang=js&"
import style0 from "./boothMap.vue?vue&type=style&index=0&id=22fcc31f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fcc31f",
  null
  
)

export default component.exports